import React, { useEffect, useRef } from 'react';
import './css/app1.css';
import { Link } from 'react-router-dom';
import WhatWeDoImg1 from './icons/services icon-01.png';
import WhatWeDoImg2 from './icons/services icon-02.png';
import WhatWeDoImg3 from './icons/services icon-03.png';
import WhatWeDoImg4 from './icons/services icon-04.png';
import WhatWeDoImg5 from './icons/services icon-05.png';
import WhatWeDoImg6 from './icons/services icon-06.png';

export default function WhatWeDo() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show-animation');
            observer.unobserve(entry.target); // run only once
          }
        });
      },
      { threshold: 0.2 } // triggers when 20% of section visible
    );

    const section = sectionRef.current;
    if (section) observer.observe(section);

    return () => {
      if (section) observer.unobserve(section);
    };
  }, []);

  return (
    <>
      <section ref={sectionRef} className="what-we-do scroll-animation">
        <div className="row section-inner-waht-we-do">
          <div className="col-md-12">
            <div className="heading-top">
              <h5>WHAT WE DO</h5>
            </div>
            <div className="main-heading-text">
              <h2>GROW YOUR BUSINESS WITH RAJ</h2>
            </div>
            <div className="main-para-text">
              <p>
                At Raj Digital Marketing, we go beyond basic promotions we help
                brands establish authority, build recognition, and boost
                profitability. In today’s competitive digital landscape, it’s
                not just about being seen it’s about being remembered.
              </p>
            </div>
          </div>
        </div>

        <div className="row section-main-boxes">
          {[WhatWeDoImg1, WhatWeDoImg2, WhatWeDoImg3, WhatWeDoImg4, WhatWeDoImg5, WhatWeDoImg6].map(
            (img, index) => (
              <div className="col-md-4" key={index}>
                <div className="box-inner-parent">
                  <div className="imagesec">
                    <img src={img} alt="Service" />
                  </div>
                  <div className="heading-box">
                    <h4>
                      {[
                        'SEARCH ENGINE OPTIMIZATION – SEO',
                        'Website Design & Development',
                        'Social Media Marketing',
                        'Content Writing',
                        'Graphic Designing',
                        'Ads Management',
                      ][index]}
                    </h4>
                  </div>
                  <div className="para-box">
                    <p>
                      {[
                        'With thorough keyword research and ethical SEO techniques, we can help you secure top positions in major search engines.',
                        "With lots of websites online, it's crucial to ensure your website stands out, reflects your brand effectively, and most importantly, drives growth for your organization.",
                        'In today’s digital era, social media marketing is crucial for businesses of all sizes. We ensure your brand or product reaches your target audience, keeping your social community actively engaged.',
                        'Our content writers are skilled in Search Engine Optimization and by integrating best SEO practices, we ensure that your content not only engages readers but also improves your website’s visibility in search engine results.',
                        'We create engaging designs that effectively communicate your message and resonate with your audience. Let us help you stand out in a competitive market.',
                        'We handle everything from strategy to execution, ensuring your ads reach the right audience and deliver measurable results.',
                      ][index]}
                    </p>
                  </div>
                  <div className="button-box">
                    <Link to="/">
                      Enquire Now +
                    </Link>
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </section>
    </>
  );
}
